import React, { useMemo } from 'react';
import { PaymentMethodType } from '../../../enums';

import Visa from './icons/visa.svg';
import MasterCard from './icons/mastercard.svg';
import Diners from './icons/diners.svg';
import MIR from './icons/mir.svg';
import UnionPay from './icons/unionpay.svg';
import Discover from './icons/discover.svg';
import Amex from './icons/amex.svg';
import JCB from './icons/jcb.svg';
import Generic from './icons/generic.svg';

type Props = {
    type: PaymentMethodType;
    size?: 'default' | 'small' | 'large';
}
const PaymentMethodIcon: React.FC<Props> = ({ type, size }) => {

    const img = useMemo(() => {
        switch (type) {
            case PaymentMethodType.AMEX:
                return Amex;
            case PaymentMethodType.Diners:
                return Diners;
            case PaymentMethodType.Discover:
                return Discover;
            case PaymentMethodType.JCB:
                return JCB;
            case PaymentMethodType.MIR:
                return MIR; 1
            case PaymentMethodType.Visa:
                return Visa;
            case PaymentMethodType.Mastercard:
                return MasterCard;
            case PaymentMethodType.UnionPay:
                return UnionPay;
            case PaymentMethodType.Generic:
            default:
                return Generic;
        }
    }, [type]);

    const width = useMemo(() => {
        switch (size) {
            case 'small':
                return 30;
            case 'large':
                return 50;
            default:
            case 'default':
                return 40;
        }
    }, [size]);

    return <img src={img} width={width} className='border'></img>;
}

export default PaymentMethodIcon;